/**
 * Satu bingkai preview: dokumen render yang sama persis, dimuat di iframe
 * berukuran asli (mis. 1080×1350) lalu diperkecil dengan CSS transform.
 *
 * `sandbox="allow-scripts"` TANPA `allow-same-origin`: dokumen berisi teks
 * user dan menjalankan script template (pengecil judul), jadi ia hidup di
 * origin buram — tidak bisa membaca cookie atau DOM orisini.com.
 */
export default function PosterPreview({
  doc,
  width,
  height,
  displayWidth,
  label,
}: {
  doc: string | null
  width: number
  height: number
  displayWidth: number
  label?: string
}) {
  const skala = displayWidth / width

  return (
    <figure className="flex flex-col gap-1.5">
      <div
        className="relative overflow-hidden rounded-md border border-border bg-muted"
        style={{ width: displayWidth, height: Math.round(height * skala) }}
      >
        {doc ? (
          <iframe
            title={label ?? 'Preview'}
            sandbox="allow-scripts"
            srcDoc={doc}
            tabIndex={-1}
            aria-hidden
            className="pointer-events-none absolute left-0 top-0 origin-top-left border-0"
            style={{ width, height, transform: `scale(${skala})` }}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-xs text-muted-foreground">
            Loading…
          </div>
        )}
      </div>
      {label && <figcaption className="text-xs text-muted-foreground">{label}</figcaption>}
    </figure>
  )
}
